// client/src/pages/Contact.js

import React from 'react';

const Contact = () => {
  return (
    <section className="section-wrapper bg-white text-deep-navy px-6 py-16 md:px-20">
      <div className="max-w-3xl mx-auto prose prose-lg">
        <h1>Get Involved</h1>
        <p>
          Interested in joining the Better Turns movement? Whether you’re a
          retailer, vendor, partner, or simply passionate about fairer retail —
          we’d love to hear from you.
        </p>
        <p>
          Drop us a line at <strong>team@betterturns.com</strong> or use the
          contact form (coming soon!).
        </p>
      </div>
    </section>
  );
};

export default Contact;
